(() => {
  let initialized = false;
  function getTopbarElement() {
    return document.getElementById('systemAnnouncementsTopbar');
  }
  function getTopbarOffset() {
    const rootStyles = window.getComputedStyle(document.documentElement);
    const topbarOffsetRaw = rootStyles.getPropertyValue('--system-announcements-topbar-offset').trim();
    const topbarOffset = parseInt(topbarOffsetRaw, 10);
    return Number.isFinite(topbarOffset) ? topbarOffset : 0;
  }
  function updateTopbarOffsetCssVar() {
    const topbar = getTopbarElement();
    const height = topbar ? Math.max(0, Math.ceil(topbar.getBoundingClientRect().height)) : 0;
    document.documentElement.style.setProperty('--system-announcements-topbar-offset', `${height}px`);
    return height;
  }
  function applyOffsetToOptInLayers() {
    const offset = getTopbarOffset();
    const layers = document.querySelectorAll('[data-system-announcements-offset="top"]');
    layers.forEach(elm => {
      if (!(elm instanceof HTMLElement)) {
        return;
      }
      const style = window.getComputedStyle(elm);
      if (style.position !== 'fixed' && style.position !== 'sticky' && style.position !== 'absolute') {
        return;
      }
      const topPx = parseFloat(style.top || '0');
      const originalTop = elm.dataset.systemAnnouncementsOriginalTop ?? `${Number.isFinite(topPx) ? topPx : 0}`;
      elm.dataset.systemAnnouncementsOriginalTop = originalTop;
      elm.style.setProperty('top', `calc(${originalTop}px + ${offset}px)`, 'important');
    });
  }
  function refresh() {
    updateTopbarOffsetCssVar();
    applyOffsetToOptInLayers();
  }
  function init() {
    if (initialized) {
      refresh();
      return;
    }
    initialized = true;
    refresh();
    window.addEventListener('resize', refresh);
    window.addEventListener('load', refresh);
    const topbar = getTopbarElement();
    if (topbar && window.ResizeObserver) {
      const ro = new ResizeObserver(refresh);
      ro.observe(topbar);
    }
  }
  window.systemAnnouncementsTopbar = {
    init,
    refresh,
    getTopbarOffset
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }
})();